import deepExtend from 'deep-extend';

export const INFO_WINDOW_POSITION = {
    TOP: {
        label: 'Above the marker',
        value: 'TOP',
    },
    LEFT: {
        label: 'To the left of the marker',
        value: 'LEFT',
    },
    BOTTOM: {
        label: 'Below the marker',
        value: 'BOTTOM',
    },
    RIGHT: {
        label: 'To the right of the marker',
        value: 'RIGHT',
    },
};

export const BASE_STYLE = {
    background: '#fff',
    fontColor: '#000',
    container: {
        padding: 30,
        borderRadius: 3,
        top: 0,
        left: 0,
    },
    border: {
        enabled: true,
        width: 1,
        color: '#bbb',
    },
    arrow: {
        enabled: true,
        length: 15,
    },
    shadow: {
        enabled: true,
        h: 0,
        v: 1,
        blur: 3,
        spread: 0,
        opacity: 0.3,
        color: '#000000',
    },
};

const parseIndex = (styleIndex) => {
    let i = parseInt(styleIndex, 10);
    if (isNaN(i)) {
        i = 0;
    }
    return i;
};

export const mergeFormAndStyle = (formValues, styleIndex) => {
    const i = parseIndex(styleIndex);
    return deepExtend({}, BASE_STYLE, formValues, INFO_WINDOW_STYLES[i].values, { style: i });
};

export const getDefaultValues = (styleIndex) => {
    const i = parseIndex(styleIndex);
    return deepExtend({}, BASE_STYLE, INFO_WINDOW_STYLES[i].values);
};

export const INFO_WINDOW_STYLES = [
    {
        label: 'Default Light',
        values: {},
    },
    {
        label: 'Default Dark',
        values: {
            background: '#333',
            fontColor: '#fff',
            border: {
                enabled: false,
            },
            shadow: {
                opacity: 0.75,
            },
        },
    },
    {
        label: 'Light flat',
        values: {
            background: '#fff',
            fontColor: '#333',
            container: {
                borderRadius: 0,
            },
            border: {
                enabled: false,
            },
            shadow: {
                enabled: false,
            },
        },
    },
    {
        label: 'Dark flat',
        values: {
            background: '#333',
            fontColor: '#fff',
            container: {
                borderRadius: 0,
            },
            border: {
                enabled: false,
            },
            shadow: {
                enabled: false,
            },
        },
    },
    {
        label: 'Light bold',
        values: {
            background: '#fff',
            fontColor: '#333',
            container: {
                padding: 40,
                borderRadius: 0,
            },
            border: {
                width: 5,
                color: '#333',
            },
            shadow: {
                h: 10,
                v: 10,
                blur: 0,
                spread: 0,
                opacity: 0.5,
            },
            arrow: {
                length: 20,
            },
        },
    },
    {
        label: 'Dark bold',
        values: {
            background: '#333',
            fontColor: '#fff',
            container: {
                padding: 40,
                borderRadius: 0,
            },
            border: {
                width: 5,
                color: '#fff',
            },
            shadow: {
                h: 10,
                v: 10,
                blur: 0,
                spread: 0,
                opacity: 0.75,
            },
            arrow: {
                length: 20,
            },
        },
    },
];
